var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":_vm.viewBox,"fill":_vm.fill,"stroke":_vm.stroke}})}
var staticRenderFns = []

export { render, staticRenderFns }